import HistoryModal from './HistoryModal';
export default HistoryModal;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/LockUnlockPanel/HistoryModal/index.js